module.exports = __webpack_public_path__ + "static/media/menuBNTMobile.2bbeca1d.png";